import React, { Component } from 'react'
import { FormattedDate, FormattedMessage, FormattedNumber } from "react-intl";
import SectionWrapper from "../../sectionwrapper.component.jsx";
import GlobalHelper from '../../../../common/GlobalHelper.jsx';
class CustomerAgeingReportContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function () { },
            id: this.props.id || '',
            interval: 30,
            currency: this.props.variables.global.baseCurrency,
            customerAgeingReport: {
                totalBalance: 0,
                bucket0: 0,
                bucket1: 0,
                bucket2: 0,
                bucket3: 0,
                bucket4: 0,
            },
        }
        this.showEdition = this.showEdition.bind(this)
        this.hideEdition = this.hideEdition.bind(this)
    }

    UNSAFE_componentWillMount() {
        this.loadAgeingReport()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            id: nextProps.id || '',
        })
    }

    loadAgeingReport() {
        const customerAgeingReport = Object.assign({}, this.state.customerAgeingReport)
        const ageingReports = this.props.variables.customer.ageingReport || []
        for (let ageingReport of ageingReports) {
            customerAgeingReport.bucket0 += parseFloat(ageingReport.bucket0)
            customerAgeingReport.bucket1 += parseFloat(ageingReport.bucket1)
            customerAgeingReport.bucket2 += parseFloat(ageingReport.bucket2)
            customerAgeingReport.bucket3 += parseFloat(ageingReport.bucket3)
            customerAgeingReport.bucket4 += parseFloat(ageingReport.bucket4)
            customerAgeingReport.totalBalance += parseFloat(ageingReport.totalBalance)
        }
        this.setState({
            customerAgeingReport,
        })
    }

    showEdition() {
        if (this.state.editable) {
            this.setState({
                edition: true,
            })
        }
    }

    hideEdition() {
        if (this.state.editable) {
            this.setState({
                edition: false,
            })
        }
    }

    render() {
        const breakpoint = this.props.isPdf ? 'sm' : GlobalHelper.getResponsiveBreakpoint();
        const lastUpdateDate = this.state.variables.quote.effectiveDate
            || this.state.variables.customer.customerAccount.attributes.updatedAt
        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                {breakpoint !== 'xs' &&
                    <table className="table my-3 table-sm">
                        <thead className="thead-light">
                            <tr>
                                <th scope="col" style={{ width: "17%" }}>
                                    <FormattedMessage
                                        id="invoice.report.ageing.headers.last_days_balance_label"
                                        defaultMessage="Last {count} days"
                                        values={{
                                            count: this.state.interval
                                        }}
                                    />
                                </th>
                                <th scope="col" style={{ width: "17%" }} className={' d-none d-sm-table-cell'}>
                                    <FormattedMessage
                                        id="invoice.report.ageing.headers.over_days_balance_label"
                                        defaultMessage="Over {count} days"
                                        values={{
                                            count: this.state.interval
                                        }}
                                    />
                                </th>
                                <th scope="col" style={{ width: "17%" }} className={' d-none d-sm-table-cell'}>
                                    <FormattedMessage
                                        id="invoice.report.ageing.headers.over_days_balance_label"
                                        defaultMessage="Over {count} days"
                                        values={{
                                            count: this.state.interval * 2
                                        }}
                                    />
                                </th>
                                <th scope="col" style={{ width: "17%" }} className={' d-none d-sm-table-cell'}>
                                    <FormattedMessage
                                        id="invoice.report.ageing.headers.over_days_balance_label"
                                        defaultMessage="Over {count} days"
                                        values={{
                                            count: this.state.interval * 3
                                        }}
                                    />
                                </th>
                                <th scope="col" style={{ width: "17%" }} className={' d-none d-sm-table-cell'}>
                                    <FormattedMessage
                                        id="invoice.report.ageing.headers.over_days_balance_label"
                                        defaultMessage="Over {count} days"
                                        values={{
                                            count: this.state.interval * 4
                                        }}
                                    />
                                </th>
                                <th scope="col" style={{ width: "15%" }} className={'text-right'}>
                                    <FormattedMessage
                                        id="invoice.report.ageing.headers.total_balance_label"
                                        defaultMessage="Owing balance"
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <FormattedNumber
                                        style="currency"
                                        currency={this.state.currency}
                                        value={this.state.customerAgeingReport.bucket0}
                                    />
                                </td>
                                <td className={' d-none d-sm-table-cell'}>
                                    <FormattedNumber
                                        style="currency"
                                        currency={this.state.currency}
                                        value={this.state.customerAgeingReport.bucket1}
                                    />
                                </td>
                                <td className={' d-none d-sm-table-cell'}>
                                    <FormattedNumber
                                        style="currency"
                                        currency={this.state.currency}
                                        value={this.state.customerAgeingReport.bucket2}
                                    />
                                </td>
                                <td className={' d-none d-sm-table-cell'}>
                                    <FormattedNumber
                                        style="currency"
                                        currency={this.state.currency}
                                        value={this.state.customerAgeingReport.bucket3}
                                    />
                                </td>
                                <td className={' d-none d-sm-table-cell'}>
                                    <FormattedNumber
                                        style="currency"
                                        currency={this.state.currency}
                                        value={this.state.customerAgeingReport.bucket4}
                                    />
                                </td>
                                <td className={'text-right pr-2 '
                                    + (parseFloat(this.state.customerAgeingReport.totalBalance) > 0 ? 'table-dark' : '')}>
                                    <FormattedNumber
                                        style="currency"
                                        currency={this.state.currency}
                                        value={this.state.customerAgeingReport.totalBalance}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="6">
                                    <small className={'mr-4'}>
                                        <FormattedMessage
                                            id="proposal.customer_account_statement.last_update_label"
                                            defaultMessage="Last update : {date}"
                                            values={{
                                                date: <FormattedDate
                                                    year='numeric'
                                                    month='long'
                                                    day='numeric'
                                                    value={new Date(lastUpdateDate)}
                                                />

                                            }}
                                        />
                                    </small>
                                </td>
                            </tr>
                        </tbody>
                    </table>}

                {(breakpoint === 'xs') &&
                    <table className="table my-3 table-sm">
                        <tr>
                            <th scope="col" style={{ width: "50%" }} className={'bg-light'}>
                                <FormattedMessage
                                    id="invoice.report.ageing.headers.last_days_balance_label"
                                    defaultMessage="Last {count} days"
                                    values={{
                                        count: this.state.interval
                                    }}
                                />
                            </th>
                            <td className={'text-right'}>
                                <FormattedNumber
                                    style="currency"
                                    currency={this.state.currency}
                                    value={this.state.customerAgeingReport.bucket0}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th scope="col" style={{ width: "50%" }} className={'bg-light'}>
                                <FormattedMessage
                                    id="invoice.report.ageing.headers.over_days_balance_label"
                                    defaultMessage="Over {count} days"
                                    values={{
                                        count: this.state.interval
                                    }}
                                />
                            </th>
                            <td className={'text-right'}>
                                <FormattedNumber
                                    style="currency"
                                    currency={this.state.currency}
                                    value={this.state.customerAgeingReport.bucket1}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th scope="col" style={{ width: "50%" }} className={'bg-light'}>
                                <FormattedMessage
                                    id="invoice.report.ageing.headers.over_days_balance_label"
                                    defaultMessage="Over {count} days"
                                    values={{
                                        count: this.state.interval * 2
                                    }}
                                />
                            </th>
                            <td className={'text-right'}>
                                <FormattedNumber
                                    style="currency"
                                    currency={this.state.currency}
                                    value={this.state.customerAgeingReport.bucket2}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th scope="col" style={{ width: "50%" }} className={'bg-light'}>
                                <FormattedMessage
                                    id="invoice.report.ageing.headers.over_days_balance_label"
                                    defaultMessage="Over {count} days"
                                    values={{
                                        count: this.state.interval * 3
                                    }}
                                />
                            </th>
                            <td className={'text-right'}>
                                <FormattedNumber
                                    style="currency"
                                    currency={this.state.currency}
                                    value={this.state.customerAgeingReport.bucket3}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th scope="col" style={{ width: "50%" }} className={'bg-light'}>
                                <FormattedMessage
                                    id="invoice.report.ageing.headers.over_days_balance_label"
                                    defaultMessage="Over {count} days"
                                    values={{
                                        count: this.state.interval * 4
                                    }}
                                />
                            </th>

                            <td className={'text-right'}>
                                <FormattedNumber
                                    style="currency"
                                    currency={this.state.currency}
                                    value={this.state.customerAgeingReport.bucket4}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th scope="col" style={{ width: "50%" }} className={'bg-light'}>
                                <FormattedMessage
                                    id="invoice.report.ageing.headers.total_balance_label"
                                    defaultMessage="Owing balance"
                                />
                            </th>
                            <td className={'text-right pr-2 '
                                + (parseFloat(this.state.customerAgeingReport.totalBalance) > 0 ? 'table-dark' : '')}>
                                <FormattedNumber
                                    style="currency"
                                    currency={this.state.currency}
                                    value={this.state.customerAgeingReport.totalBalance}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="6">
                                <small className={'mr-4'}>
                                    <FormattedMessage
                                        id="proposal.customer_account_statement.last_update_label"
                                        defaultMessage="Last update : {date}"
                                        values={{
                                            date: <FormattedDate
                                                year='numeric'
                                                month='long'
                                                day='numeric'
                                                value={new Date(lastUpdateDate)}
                                            />

                                        }}
                                    />
                                </small>
                            </td>
                        </tr>
                    </table>}
            </SectionWrapper>
        );
    }
}

export default CustomerAgeingReportContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/customer-ageing-report/section.component.jsx